// The Rails app wired the hero, pricing and service-panel buttons to jQuery tab
// activation (`$('#inquiry-button').tab('show')` in form_activator.coffee), so
// "Angebot anfordern" scrolled to the form *and* selected the inquiry tab, while
// "Bewerbung zur Mitarbeit" selected the work-for-us one. InquiryWidget keeps
// that tab in local state, which the buttons cannot reach directly – they are
// rendered by unrelated widgets – so they announce their intent as a DOM event
// and the form listens for it.
export const INQUIRY_TAB_EVENT = 'tt:inquiry-tab';

// `tab` is 'inquiry' or 'work'.
export function requestInquiryTab(tab) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(INQUIRY_TAB_EVENT, { detail: tab }));
}
